var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlavor4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1068)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4765 4.01149L8.00813 5.24217C7.64207 6.53909 6.41836 7.44554 5.14584 7.7628C3.53167 8.15327 0.52295 7.78721 0.0592662 5.88018C-0.407904 3.97314 2.08832 2.25786 3.69901 1.86739C4.97153 1.55014 6.48809 1.79418 7.39105 2.77384L15.5944 0.389182C16.5706 0.0963291 17.6235 0.657631 17.9198 1.63729C18.2371 2.68668 17.5747 3.78837 16.4765 4.00801",
    fill: "#A36129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.99594 10.5239C4.99594 10.1091 4.65428 9.76392 4.215 9.76392C3.80013 9.76392 3.45847 10.1056 3.45847 10.5239C3.45847 10.9423 3.80013 11.284 4.215 11.284C4.65428 11.284 4.99594 10.9423 4.99594 10.5239Z",
    fill: "#A36129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.94711 14.9273C4.94711 14.5124 4.60545 14.1672 4.18709 14.1672C3.76872 14.1672 3.42706 14.5089 3.42706 14.9273C3.42706 15.3456 3.76872 15.6873 4.18709 15.6873C4.60545 15.6873 4.94711 15.3456 4.94711 14.9273Z",
    fill: "#A36129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85357 12.4102C5.85357 11.9953 5.51191 11.6501 5.09355 11.6501C4.67519 11.6501 4.33353 11.9918 4.33353 12.4102C4.33353 12.8285 4.67519 13.1702 5.09355 13.1702C5.51191 13.1702 5.85357 12.8285 5.85357 12.4102Z",
    fill: "#A36129"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.13772 12.9226C3.13772 12.5077 2.79606 12.1626 2.3777 12.1626C1.95934 12.1626 1.61768 12.5043 1.61768 12.9226C1.61768 13.341 1.95934 13.6826 2.3777 13.6826C2.79606 13.6826 3.13772 13.341 3.13772 12.9226Z",
    fill: "#A36129"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1068"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 15.3748,
    fill: "white",
    transform: "translate(0 0.3125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlavor4);
export default __webpack_public_path__ + "static/media/flavor_4.c13904c3fffc34dfcc5e893c89518250.svg";
export { ForwardRef as ReactComponent };